module.exports = __webpack_public_path__ + "img/price-last.5350fe6f.png";